import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UserAuthGuard  {

  constructor(private _auth: AuthService, private _router: Router) { }

  canActivate(): Observable<boolean> {
    
    return this._auth.getUser().pipe(map(u => !!u));

  }
}
